import type { ReactNode } from "react";

interface ReviewerAvatarProps {
  // Reviews arrive from the API, so a missing name is a data question, not a
  // Type one — and this used to throw, which takes the whole page down.
  review: { name?: string; profileImageUrl?: string };
}

const ReviewerAvatar = ({ review }: ReviewerAvatarProps): ReactNode => {
  if (typeof review.profileImageUrl === "string" && review.profileImageUrl !== "") {
    return (
      <img
        src={review.profileImageUrl}
        alt={review.name}
        referrerPolicy="no-referrer"
        className="jobsite:h-9 jobsite:w-9 jobsite:shrink-0 jobsite:rounded-full jobsite:object-cover"
      />
    );
  }

  const initials = (review.name ?? "")
    .split(" ")
    .filter(Boolean)
    .map((word) => word[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <div className="jobsite:flex jobsite:h-9 jobsite:w-9 jobsite:shrink-0 jobsite:items-center jobsite:justify-center jobsite:rounded-full jobsite:bg-muted jobsite:text-xs jobsite:font-semibold jobsite:text-muted-foreground">
      {initials}
    </div>
  );
};

export { ReviewerAvatar };
